import { z } from 'zod';

export const DocumentValidationIssueSchema = z.object({
  code: z.string().optional(),
  message: z.string(),
  path: z.array(z.union([z.string(), z.number()])).optional(),
});
export const DocumentValidationReviewSchema = z.object({
  status: z.literal('FAILED'),
  kind: z.enum(['DATA', 'TECHNICAL']),
  issues: z.array(DocumentValidationIssueSchema),
  rulesetVersion: z.string().optional(),
});
export type DocumentValidationReview = z.infer<typeof DocumentValidationReviewSchema>;
